import type { UserAttributes } from '~/types';

export const useAuthStore = defineStore('auth', () => {
    const api = useApi();
    const user = ref<UserAttributes>();
    const isAuthenticated = computed(() => !!user.value);

    const fetch = async () => user.value = await api<UserAttributes>('users');
    const logout = async () => {
        return api('logout', { method: 'POST' })
            .then(() => user.value = undefined)
            .catch(errorResponse => {
                const handler = parseError(errorResponse);

                // we're already logged out
                if (handler.isUnauthenticatedError) {
                    user.value = undefined;
                    return;
                }

                throw errorResponse;
            });
    };

    return {
        user,
        isAuthenticated,
        logout,
        fetch
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useAuthStore, import.meta.hot));
}
